<template>
  <div>
    <div class="banner">
      <img data-v-fae5bece="" src="http://www.lvshouhotel.com/lvshouhotel/img_bg_news.png">
    </div>
    <ArticalOne v-if="$route.query.id == 0"></ArticalOne>
    <ArticalTow v-if="$route.query.id == 1"></ArticalTow>
  </div>
</template>
<script>
import ArticalOne from "@/components/hotelDynamic/articalOne";
import ArticalTow from "@/components/hotelDynamic/articalTow";

export default {
  name:'artical',
  data(){
    return{

    }
  },
  methods:{
   
  },
  components:{
    ArticalOne,
    ArticalTow
  }
}
</script>


<style lang="less">
// 文章详情样式
.artical-detial{
  padding-bottom: 240px;
  .artical-title{
    padding: 72px 0 104px;
    h2{
      font-size: 38px;
      color: #584339;
      letter-spacing: 1px;
      line-height: 38px;
      &:nth-child(2){
        padding-top:32px;
      }
    }
  }
  .artical-body{
    width: 967px;
    margin: 0 auto;
    h3{
      font-size: 22px;
      color: #333333;
      letter-spacing: 0;
    }
    p{
      font-size: 16px;
      letter-spacing: 1.8px;
      color: #666666;
      line-height: 40px;
      padding-bottom: 40px;
      text-indent: 2rem;
    }
    img{
      display: block;
      width: 699px;
      margin:16px auto 0px;
    }
    .img-desc{
      letter-spacing: 1.8px;
      font-size: 12px;
      color: #999;
      text-indent:0;
    }
  }
}

</style>
